<template>
<div>
  <div class="header other-banner other-banner-clause" id="">
    <div class="container">
      <div class="other-banner-title">{{ $t('clause.Policies') }}</div>
    </div>
  </div>
  <!--content-->
  <div class="content bgf5f5f5">
    <div>&nbsp;</div>
    <div class="container sub-nav clause-nav">
      <div class="col-md-12">
        <router-link to="clauseConditions" class=" ">{{ $t('clause.TermsConditions') }}</router-link>
        <router-link to="clauseService" class=" ">{{ $t('clause.ServiceDisclaimer') }}</router-link>
        <router-link to="clausePrivacy" class=" cur">{{ $t('clause.PrivacyDisclaimer') }}</router-link>

      </div>
    </div>
    <!--帮助中心-->
    <div class="container col-jj">
      <div class="col-md-12">
        <div class="clause_con">
          <div class="clause_w_con" style="line-height:1.6;">
            <html-panel :url.asyc="privacy_policy_url"></html-panel>
          </div>
        </div>
      </div>

    </div>
    <!--帮助中心../-->

  </div>
</div>
</template>

<script>
    export default {
        name: "clause03",
        data(){
          return{
           // privacy_policy_url: 'https://www.orangeconnex.com/customer/privacy-policy.html'
           privacy_policy_url: '/customer/privacy-policy.html'
          }
        }
    }
</script>




// WEBPACK FOOTER //
// clause03.vue?57b46c13